const STYLE_HOME_PAGE = 'home';

/**
 * @returns {boolean}
 */
export function isHomePage() {
    return document.body.classList.contains(STYLE_HOME_PAGE);
}